// Fix jQuery passive listener
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

jQuery(document).ready(function ($) {
    function debounce(func, wait) {
        var timer = null;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        }
    }

    // Trigger whatsapp (open/close)
    var whatsappPopup = $('#whatsapp-popup');

    $('[data-whatsapp-popup="toggle"]').click(function(event) {
        whatsappPopup.toggleClass('is-active');
        whatsappPopup.fadeToggle('fast');
        if (whatsappPopup.hasClass('is-active')) {
            $(whatsappPopup).find('input:first').focus();
            $('html').css({'overflow': 'hidden'});
        } else {
            setTimeout(function(){
                $('html').css({'overflow': ''});
            }, 300);
        }
    });

    // Trigger faq (open/close)
    $('[data-faq="toggle"]').click(function(event) {
        if ($(this).siblings('.item-text').is(':hidden')) {
            $('.faq-item .item-header').removeClass('is-active');
            $('.faq-item .item-text').slideUp();
            $(this).addClass('is-active');
            $(this).siblings('.item-text').slideDown();
        } else {
            $(this).removeClass('is-active');
            $(this).siblings('.item-text').slideUp();
        }
    });

    // Nome do arquivo no input
    if ($("body").has("#input-file").length) {
        // click input file
        $('#input-file-btn').click(function() {
            $('#input-file').click();
        });

        var defaultText = $("#input-file-name").text();

        $('#input-file').bind('change', function(){
            $("#input-file-name").html(this.value.split(/(\\|\/)/g).pop());
            if ($('#input-file-name').is(':empty')){
                $("#input-file-name").html(defaultText);
            }
        });
    }

    // Anchor scroll
    $('a[href*="#"]:not([href="#"])').click(function (event) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var el = this;
            var hash = $($(this).attr('href'));
            var target = hash.length ? hash : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);

                // Mudar hash na URL
                history.pushState({}, '', el.href);
            }
        }
    });

    $('a[href="#"]').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });

    /*
    var hash = location.hash;

    if ($("body").has(hash).length) {
        $('html, body').animate({
            scrollTop: $($(hash).offset().top)
        }, 1000);
    }
    */

    $('.gallery-popup, .wp-block-gallery').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            tLoading: 'Carregando a imagem...',
            mainClass: 'mfp-no-margins mfp-fade',
            removalDelay: 300,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: 'A imagem não pode ser carregada.',
            },
        });
    });
});
//# sourceMappingURL=data:application/json;charset=utf8;base64,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
